<template>
  <div class="card-header border-bottom pt-1 pb-1">
    <h4 class="card-title">Designation</h4>
  </div>

  <div class="card-body mt-2">
    <form @submit.prevent="storeContact(employmentDesignation)">
      <div class="row">
        <div class="col-sm-6 offset-md-3 col-12">
          <div class="row"  v-for="(des, index) in employmentDesignation">
            <div class="col-12">
              <div class="mb-1">
                <label class="col-form-label">Designation</label>
                <v-select
                    placeholder="Select Designation"
                    v-model="des.designation"
                    :options="designationList"
                    label="name"
                />
              </div>
            </div>
            <div class="col-12">
              <div class="mb-1">
                <label class="col-form-label">Effective Date</label>
                <input type="date" id="full-name" required class="form-control" v-model="des.employment_designation_effective_date"
                       placeholder="Effective Date" />
              </div>
            </div>
            <div class="col-12">
              <div class="mb-1">
                <label class="col-form-label">Remarks</label>
                <input type="text" id="full-name" class="form-control" v-model="des.employment_designation_remarks"
                       placeholder="Remarks" />
              </div>
            </div>

            <div class="col-sm-6 offset-sm-3">
              <button type="submit" class="btn btn-primary me-1">Submit</button>
              <button @click="reset" type="reset" class="btn btn-outline-secondary">Reset</button>
            </div>

          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="card-body mt-2">
    <div class="card p-2" style="min-height: 200px">
      <div class="table-responsive">
        <table class="table">
          <thead>
          <tr>
            <th>Sl No.</th>
            <th>Effective Date</th>
            <th>Designation</th>
            <th>Remarks</th>
            <th>Updated Date</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, i) in logList" :key="i">
            <td>{{ i+1 }}</td>
            <td>{{ item.employment_designation_effective_date }}</td>
            <td>{{ item.employment_designation_name }}</td>
            <td>{{ item.employment_designation_remarks }}</td>
            <td>{{ item.update_date }}</td>
          </tr>
          </tbody>
        </table>
        <p v-if="logList.length < 0" class="text-center mt-5">No data</p>
      </div>
    </div>
  </div>

</template>

<script setup>
import {defineProps, onMounted, ref, watch} from "vue";
import {useRoute} from "vue-router";
import handleDesignation from "@/services/modules/procurement/organization-settings/designation";
import handleHrPayroll from '@/services/modules/hrPayroll/hrPayroll'

const props = defineProps({
  items: {
    type: Array
  }
})

const emit = defineEmits(['storeContact'])
const route = useRoute()
const { fetchDesignationList } = handleDesignation()
let logList = ref([])
let designationList = ref([])
const { fetchContactItemLogs } = handleHrPayroll()

const employmentDesignation  = ref([
    {
      designation: '',
      employment_designation_effective_date:'',
      employment_designation_remarks:'',
    }
])

const storeContact = (data) => {
  let items = data.map(item => ({
    employment_designation: parseInt(item.designation.id),
    employment_designation_name: item.designation.name,
    employment_designation_effective_date: item.employment_designation_effective_date,
    employment_designation_remarks: item.employment_designation_remarks,
  }));

  emit('storeContact', {'items':items})
}

function getQuery() {
  return `?company_id=${route.params.companyId}`;
}

const getLogList = async () => {
  let query = getQuery()
  query += `&contact_profile_id=${route.query.contactId}&field=employment_designation`
  logList.value = []

  await fetchContactItemLogs(query).then(res => {
    if (!res.status){
      logList.value = []
      return
    }
    logList.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

const getDesignationList = async () => {
  let query = getQuery();

  designationList.value = []

  await fetchDesignationList(query).then(res => {
    if (!res.status){
      designationList.value = []
      return
    }
    designationList.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

const reset = () => {
  employmentDesignation.value.length = 0;
}

watch(() => props.items, (newFormData) => {
  formDataSet();
});

const formDataSet = () => {
    if (props.items.length){
      employmentDesignation.value = props.items.map(item => ({
        ...item,
        designation:{
          id: parseInt(item.employment_designation),
          name: item.employment_designation_name
        },
        employment_designation_effective_date: item.employment_designation_effective_date,
        employment_designation_remarks: item.employment_designation_remarks,
      }));
    }
}

onMounted(() => {
  Promise.all([
    getDesignationList(),
    getLogList()
  ])
})

</script>
